import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as LabelAssignmentService from 'services/agents/label-assignment';

export const useLabelAssignmentService = () => {
  const { token } = useSelector((store) => store.user_data);

  const createLabelAssignment = async (data, options = {}) => {
    const { error, payload: label_assignment } = await LabelAssignmentService.create({
      ...options,
      data,
      token
    });

    if (error) {
      toast.error('Cannot assign label at this time');
      return { label_assignment: null };
    }

    return { label_assignment };
  };

  const deleteLabelAssignment = async (id, options = {}) => {
    const { error } = await LabelAssignmentService.deleteOne(id, { ...options, token });

    if (error) {
      toast.error('Unable to remove label at this time.');
      return false;
    }

    return true;
  };

  const fetchLabelAssignment = async (id, options = {}) => {
    const { error, payload: label_assignment } = await LabelAssignmentService.readById(id, {
      ...options,
      token
    });

    if (error) {
      toast.error(error);
      return { label_assignment: null };
    }

    return { label_assignment };
  };

  const fetchLabelAssignments = async (options = {}) => {
    const { error, payload } = await LabelAssignmentService.read({ ...options, token });

    if (error) {
      toast.error(error);
      return { label_assignments: [], size: 0 };
    }

    const {
      data: label_assignments,
      meta: { size }
    } = payload;
    return { label_assignments, size };
  };

  const searchLabelAssignments = async (keys, keyword, options = {}) => {
    const { error, payload } = await LabelAssignmentService.search(keys, keyword, {
      ...options,
      token
    });

    if (error) {
      toast.error('Unable to fetch label assignments at this time.');
      return { label_assignments: [], size: 0 };
    }

    const {
      data: label_assignments,
      meta: { size }
    } = payload;
    return { label_assignments, size };
  };

  const updateLabelAssignment = async (id, options = {}) => {
    const { error, payload } = await LabelAssignmentService.updateById(id, { ...options, token });

    if (error) {
      toast.error('Unable to update label assignment at this time.');
      return false;
    }

    return payload || true;
  };

  const updateLabelAssignments = async (options = {}) => {
    const { error } = await LabelAssignmentService.update({ ...options, token });

    if (error) {
      toast.error('Unable to update label assignments at this time.');
      return false;
    }

    return true;
  };

  const deleteLabelAssignments = async (options = {}) => {
    const { error } = await LabelAssignmentService.deleteMany({ ...options, token });

    if (error) {
      toast.error('Unable to remove labels at this time.');
      return false;
    }

    return true;
  };

  return {
    createLabelAssignment,
    deleteLabelAssignment,
    fetchLabelAssignment,
    fetchLabelAssignments,
    searchLabelAssignments,
    updateLabelAssignment,
    updateLabelAssignments,
    deleteLabelAssignments
  };
};
